import React from "react";

const BADGE_COLORS = {
  bronze: "from-orange-300 to-orange-400",
  silver: "from-gray-300 to-gray-400",
  gold: "from-yellow-300 to-yellow-400",
  platinum: "from-purple-300 to-purple-400"
};

export default function Badge({
  title,
  subtitle,
  icon = "★",
  level = "gold",
  animation = "float", // float or wiggle
  earned = false
}) {
  return (
    <div className={`floating-card group perspective-1000`}>
      <div className={`relative transform-gpu transition-all duration-700 transform-3d ${earned ? 'card-glow' : 'opacity-60 grayscale'} p-6 text-center hover:rotate-y-180`}>
        <div className="backface-hidden">
          <div className={`w-20 h-20 mx-auto rounded-full bg-gradient-to-br ${BADGE_COLORS[level]} 
                          shadow-lg flex items-center justify-center text-2xl font-bold text-white
                          transform transition-transform group-hover:scale-110`}>
            {icon}
          </div>
          <div className="mt-4 space-y-1">
            <div className="font-bold text-lg">{title}</div>
            <div className="text-sm text-gray-600">{subtitle}</div>
          </div>
        </div>
        
        <div className="absolute inset-0 backface-hidden rotate-y-180 p-6 flex items-center justify-center text-center">
          <div>
            <div className="font-semibold mb-2">How to earn</div>
            <p className="text-sm text-gray-600">{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
